export enum SortField {
    RELEVANCE = 'relevance', // This needs to stay lower case since this is also how engine sends it out
    LAST_MODIFIED_DATE = 'LastModifiedDate',
    ARCHIVE_DATE = 'ArchiveDate',
    PUBLICATION_DATE = 'PublicationDate',
    CREATION_DATE = 'CreationDate',
    LOGICAL_DELETION_DATE = 'LogicalDeletionDate',
    TITLE = 'Title',
    ORIGINAL_FILENAME = 'OriginalFilename',
    NAME = 'Name',
    LABEL = 'Label',
    START_DATE = 'StartDate',
    FINISH_DATE = 'FinishDate',
    LOGIN = 'Login',
    FIRST_NAME = 'FirstName',
    LAST_NAME = 'LastName',
    CHILD_ORDER = 'ChildOrder',
    DOTTED_KEY = 'DottedKey',
    KEY = 'Key',
    FAMILY = 'Family',
    PARENT = 'ParentDottedKey',
    INDEX_NAME = 'IndexName',
    LAST_LOGIN = 'LastLoginDate'
}
